<template>
  <v-form @submit.prevent="getActionMethod">
    <v-container>
      <v-row align="center" justify="center">
        <span class="red--text font-weight-bold">{{
          formValidator.getError("non_field_errors")
        }}</span>
        <v-col md="6">
          <v-alert :value="true" color="grey lighten-2" class="grey--text">
            <span v-if="serviceSubStage">
              Service - <strong>{{ selectedService.name }}</strong> sales sub
              stage under {{ selectedStage }}.
            </span>
            <span v-else>
              Common sales sub stage under <strong>{{ selectedStage }}</strong
              >.
            </span>
          </v-alert>
          <v-text-field
            v-model="formValues.name"
            label="Sub Stage Name"
            placeholder="Sub Stage Name"
            :error-messages="formValidator.getError('name')"
          ></v-text-field>
          <v-text-field
            v-model="formValues.order"
            label="Sub Stage Order"
            placeholder="Sub Stage Order"
            :error-messages="formValidator.getError('order')"
          ></v-text-field>
          <v-radio-group v-model="formValues.is_process" row>
            <v-radio label="Communication" :value="false"></v-radio>
            <v-radio label="Process" :value="true"></v-radio>
          </v-radio-group>

          <vue-auto-complete
            v-if="formValues.is_process"
            v-model="formValues.process_task"
            :endpoint="
              `/api/v1/crm/process-tasks/?organization__slug=${this.$store.state.shell.currentOrganizationId}`
            "
            label="Process Task"
            multiple
            background-color="grey darken-3"
            item-text="name"
            item-value="id"
          ></vue-auto-complete>

          <v-select
            v-model="formValues.category"
            :items="['Opportunity', 'Lead', 'Deal', 'Closed Deal', 'Lost Deal']"
            label="Category"
            clearable
          ></v-select>
          <vue-auto-complete
            v-model="formValues.crm_divisions"
            :endpoint="
              `/api/v1/crm/${this.$store.state.shell.currentOrganizationId}/divisions/`
            "
            multiple
            label="Departments"
            :error-messages="formValidator.getError('crm_divisions')"
            background-color="grey darken-3"
            item-text="name"
            item-value="slug"
          ></vue-auto-complete>
        </v-col>
        <v-col md="12"></v-col>
        <v-col md="6">
          <v-divider class="my-2"></v-divider>
          <v-btn
            :disabled="Object.keys(formValidator.errors).length > 0"
            class="primary"
            type="submit"
          >
            Save
          </v-btn>
          <v-btn type="reset">
            Reset
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>
<script>
import { FormValidator } from "rhr-core-shell";
export default {
  props: {
    actionData: {
      type: Object,
      required: false,
      default() {
        return {
          name: "",
          order: "",
          is_process: true,
          category: ""
        };
      }
    },
    selectedStage: {
      type: String,
      required: true
    },
    selectedStageId: {
      type: [Number, String],
      required: true
    },
    serviceSubStage: {
      type: Boolean,
      default: false
    },
    selectedService: {
      type: Object,
      required: false,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      formValues: { ...this.actionData },
      formValidator: new FormValidator(),
    };
  },
  watch: {
    formValues: {
      handler() {
        this.formValidator.setError({});
      },
      deep: true
    }
  },
  methods: {
    getActionMethod() {
      if (this.formValues.id) return this.updateSalesSubStage();
      return this.createSalesSubStage();
    },
    createSalesSubStage() {
      const salesSubStageAPI = `/api/v1/crm/sales-sub-stages/?organization__slug=${this.$route.params.orgSlug}`;
      this.formValues.sales_stage = this.selectedStageId;
      if (this.serviceSubStage) {
        this.formValues.service = this.selectedService.id;
      } else {
        this.formValues.service = null;
      }
      this.$axios
        .$post(salesSubStageAPI, this.formValues)
        .then(() => {
          this.$store.dispatch("shell/showSnackbar", {
            text: `Successfully created sales sub stage!`,
            color: "green"
          });
          if (this.serviceSubStage) {
            this.$emit("productServiceSubStageFormResponse", "created");
          } else {
            this.$emit("salesSubStageResponse", "created");
          }
        })
        .catch(error => {
          this.formValidator.setError(error.response.data);
        });
    },
    updateSalesSubStage() {
      const salesSubStageAPI = `/api/v1/crm/sales-sub-stages/${this.formValues.id}/?organization__slug=${this.$route.params.orgSlug}`;
      this.$axios
        .$patch(salesSubStageAPI, this.formValues)
        .then(() => {
          this.$store.dispatch("shell/showSnackbar", {
            text: `Successfully updated sales sub stage!`,
            color: "green"
          });
          if (this.serviceSubStage) {
            this.$emit("productServiceSubStageFormResponse", "updated");
          } else {
            this.$emit("salesSubStageResponse", "updated");
          }
        })
        .catch(error => {
          this.formValidator.setError(error.response.data);
        });
    }
  }
};
</script>
